// extracted by mini-css-extract-plugin
export default {"body":"EmbedVideos_body__vBwFZ","wrapper":"EmbedVideos_wrapper__hPswK","video":"EmbedVideos_video__ICga7"};